import { render, staticRenderFns } from "./userAssign.vue?vue&type=template&id=72d46a38&scoped=true&"
import script from "./userAssign.vue?vue&type=script&lang=js&"
export * from "./userAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d46a38",
  null
  
)

export default component.exports